;(function($) {

	"use strict";

	$(document).ready(function() {

		// ---------- Ajax Add to Cart ----------

		if(typeof ajax_add_to_cart_params !== 'undefined') {

			var add_to_cart_text = JSON.parse(ajax_add_to_cart_params.localized_text);

			//Add to cart on single page
			$(document).on('submit', 'form.cart', function(e) {
				e.preventDefault();

				var add_to_cart_btn = $(this).find('.single_add_to_cart_button');

				if(add_to_cart_btn.find('.add-to-cart-icon').length !== 0) {
					add_to_cart_btn.find('.add-to-cart-icon').html('<i class="ion-load-c fa-spin"></i>');
				}
				else {
					add_to_cart_btn.append('<span class="add-to-cart-icon"><i class="ion-load-c fa-spin"></i></span>');
				}

				if(add_to_cart_btn.length === 0) {
					var add_to_cart_btn = $(this).find('button');
				}

				var product_id = parseInt($(this).find('[name=add-to-cart]').val());
				var quantity = parseInt($(this).find('.quantity').find('.qty').val());

				ajax_add_to_cart(product_id, quantity, add_to_cart_btn);//Ajax add to cart
			});

		}

		//Add to cart ajax function
		function ajax_add_to_cart(product_id, quantity, add_to_cart_btn) {

			$.ajax({
				url:      ajax_add_to_cart_params.admin_url,
				type:     'POST',
				dataType: 'json',
				data:     {
					action:     ajax_add_to_cart_params.action,
					nonce:      ajax_add_to_cart_params.nonce,
					product_id: product_id,
					quantity:   quantity
				},
				success:  function(response, status, jqXHR) {
					add_to_cart_btn.find('.add-to-cart-icon').html('<i class="ion-ios-checkmark-outline" aria-hidden="true"></i>');
					var navbar_cart = $('.cart-icon');

					navbar_cart.find('span').text(response.data.cart_count);

					lity('<p>test</p>');
					//bootbox.dialog({
					//	backdrop:    true,
					//	closeButton: false,
					//	className:   'add-to-cart-modal',
					//	message:     '<div>' + add_to_cart_text.added + '</div>' +
					//	             '<div><a href="' + ajax_add_to_cart_params.cart_url + '" class="btn btn-primary btn-gradient btn-lg"><span>' + add_to_cart_text.checkout + '</span></a></div>',
					//	buttons:     {
					//		dismiss: {
					//			label:     add_to_cart_text.continue,
					//			className: "btn-link",
					//			callback:  function() {
					//				add_to_cart_btn.find('.add-to-cart-icon').fadeOut(500, function() {
					//					$(this).remove();
					//				});
					//				$(this).modal('hide');
					//			}
					//		}
					//	}
					//});
				}
			});
		}

	});

}(jQuery));

;(function($) {

	"use strict";

	var animationEndEvent = 'webkitAnimationEnd oAnimationEnd MSAnimationEnd animationend';
	var transitionEndEvent = 'webkitTransitionEnd oTransitionEnd MSTransitionEnd transitionend';
	var iOS = parseFloat(
		('' + (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [0, ''])[1])
			.replace('undefined', '3_2').replace('_', '.').replace('_', '')
	) || false;
	var lazyLoad;
	var skrollrOptions = {
		smoothScrolling: false,
		forceHeight:     false,
		mobileCheck:     function() {
			return false;
		}
	};

	$(document).ready(function() {

		//==================================
		//	!---------- GLOBAL ----------
		//==================================

		responsiveHoverRules();

		$('.mobile-menu-overlay').click(function(e) {
			e.preventDefault();
			$('body').removeClass('mobile-menu-open');
		});

		$('.mobile-menu-toggle').click(function(e) {
			e.preventDefault();
			$('body').toggleClass('mobile-menu-open');
			$('body').scrollTop(0);
		});

		$('a[href="#"], .void-link').click(function(e) {
			e.preventDefault();
		});

		$('a[data-scroll-to]').click(function(e) {
			e.preventDefault();

			var self = $(this);
			var target = $(self.attr('href'));

			if(target.length) {
				var offset = (target.offset().top > 320) ? target.offset().top : 0;
				$('body').animate({
					scrollTop: offset
				}, 1000);
			}
		});

		$('.carousel').each(function() {
			var self = $(this);

			self.on('init reInit beforeChange', function() {
				if(lazyLoad instanceof LazyLoad) {
					lazyLoad.update();
				}
			});

			self.slick({
				arrows:       false,
				infinite:     false,
				centerMode:   true,
				initialSlide: 1,
				focusOnSelect: false,
				slidesToShow:  3,
				accessibility: false,
				responsive:    [
					{
						breakpoint: 1024,
						settings:   {
							slidesToShow: 3,
							initialSlide:  2,
						}
					},
					{

						breakpoint: 768,
						settings:   {
							centerMode:    false,
							initialSlide:  1,
							slidesToShow:  2,
						}
					},
					{
						breakpoint: 480,
						settings:   {
							centerMode:    false,
							initialSlide:  1,
							slidesToShow:  1,
						}
					}
				]
			});
		});

		$('.slideshow').each(function() {
			var self = $(this);

			self.lightGallery({
				download: false,
			});
		});

		function skrollrInit() {
			skrollr.init(skrollrOptions);
		}

		//$(window).debounce('resize', function() {
		//	var skrollrInstance = skrollr.get();
		//
		//	if(window.innerWidth <= 767 && skrollrInstance !== undefined) {
		//		skrollrInstance.destroy();
		//	}
		//	else if(window.innerWidth > 767 && skrollrInstance === undefined) {
		//		skrollrInit();
		//	}
		//}, 200);

		$(window).trigger('resize');

		skrollrInit();

		$(window).on('load', function() {

			$(window).trigger('resize');

			var sw = new ScrollWatch({
				inViewClass:     'active',
				watchOffset:     -200,
			});

			lazyLoad = new LazyLoad({
				elements_selector: '.lazy',
				callback_set:      function(element) {
					$(element).addClass('loaded');
				}
			});
		});
	});

	// ---------- Disclaimer ----------

	$('.close-disclaimer').click(function(e) {
		e.preventDefault();

		Cookies.set('tc-disclaimer', true, {
			expires: 365,
			path:    '/',
		});

		$('#disclaimer').fadeOut(1000, function() {
			$(this).remove();
		});

		$('body').removeClass('disclaimer-open');
	});

	$('#cookies-law').on('closed.bs.alert', function() {

		Cookies.set('tc-cookies', true, {
			expires: 365,
			path:    '/',
		});

	});

	//================================
	//	!---------- TEAM ----------
	//================================

	$('.team-carousel').each(function() {
		var self = $(this);
		var settings = {
			accessibility:  false,
			arrows:         false,
			dots:           true,
			infinite:       true,
			speed:          300,
			slidesToShow:   2,
			slidesToScroll: 2,
			customPaging:   function(slider, i) {
				return '<div></div>';
			},
			responsive:     [
				{
					breakpoint: 768,
					settings:   {
						slidesToShow:   1,
						slidesToScroll: 1,
					}
				}
			]
		};

		self.on('init reInit afterChange', function() {
			if(lazyLoad instanceof LazyLoad) {
				lazyLoad.update();
			}
		});

		self.slick(settings);

		$(window).on('resize', function() {
			if(window.innerWidth > 1023) {
				if(self.hasClass('slick-initialized')) {
					self.slick('unslick');
				}
				return
			}

			if(!self.hasClass('slick-initialized')) {
				return self.slick(settings);
			}
		});

	});


	if($('.reinsurance').length) {
		$('.reinsurance .wrapper').matchHeight();
	}

}(jQuery));

function responsiveHoverRules() {
	if('ontouchstart' in document.documentElement) {
		for(var sheetI = document.styleSheets.length - 1; sheetI >= 0; sheetI--) {
			var sheet = document.styleSheets[sheetI];
			if(sheet.cssRules) {
				for(var ruleI = sheet.cssRules.length - 1; ruleI >= 0; ruleI--) {
					var rule = sheet.cssRules[ruleI];

					if(rule.selectorText) {
						rule.selectorText = rule.selectorText.replace(':hover', ':active');
					}
				}
			}
		}
	}
}



(function ($) {

	$(document).ready(function () {

	});

}(jQuery));
